import { CalendarDay, PrayerHour } from "../calendar/utils";
import { OPENING_SENTENCES } from "../pages/pray/opening-sentences";
import { LiturgyItem } from "./types";

function findHCF(x: number, y: number) {
    while (Math.max(x, y) % Math.min(x, y) != 0) {
        if (x > y) {
            x %= y;
        } else {
            y %= x;
        }
    }

    return Math.min(x, y);
}

export const getOpeningSentence = (
    day: CalendarDay,
    hour: PrayerHour
): LiturgyItem[] => {
    /*const id =
        day.eveOf && hour === "evensong"
            ? day.eveOf.sentenceId
            : day.sentenceId;*/

    const id: string = "1662";

    const sentences = OPENING_SENTENCES[id];

    if (id === "ordinary") {
        if (hour === "mattins") {
            sentences.push(...OPENING_SENTENCES["morning"]);
        } else {
            sentences.push(...OPENING_SENTENCES["evening"]);
        }
    }

    if (sentences.length === 0) {
        return [];
    } else {
        const possibleCycles = [];
        for (let i = 2; i < sentences.length; i++) {
            if (findHCF(i, sentences.length) === 1) {
                possibleCycles.push(i);
            }
        }
        const target = 0.66 * sentences.length;
        let bestCycle = -1000;
        possibleCycles.forEach((possibleCycle) => {
            if (
                Math.abs(target - possibleCycle) < Math.abs(target - bestCycle)
            ) {
                bestCycle = possibleCycle;
            }
        });

        const sentence =
            sentences[
                ((day.dayOfTheYear * 2 + (hour === "evensong" ? 1 : 0)) *
                    bestCycle) %
                    sentences.length
            ];

        return [
            {
                type: "rubric",
                content: `Before the Office, the Officiant shall read one or more sentences of Scripture.`,
            },
            { type: "text", content: sentence.text },
            { type: "spacer" },
        ];
    }
};
